import request from '@/utils/request'
import md5 from "js-md5";

export function login(data) {
  return request({
    url: '/oauth/anno/token',
    method: 'post',
    data
  }).then((res) => {
    return Promise.resolve(res);
  });
}

export function supperLogin(data) {
  return request({
    url: '/oauth/anno/innerToken',
    method: 'post',
    data
  }).then((res) => {
    return Promise.resolve(res);
  });
}

export function registerCaptcha(data, telephoneCode) {
  return request({
    url: `/oauth/anno/registerCaptcha?telephoneCode=${telephoneCode}`,
    method: 'post',
    data
  })
}

export function registerUser(data) {
  return request({
    url: `/oauth/anno/register`,
    method: 'post',
    data
  }).then((res) => {
    return Promise.resolve(res);
  });
}

export function getUserInfo(token) {
  return request.get('/oauth/anno/getAuthInfo?token=Bearer '+token)
    .then((res) => {
      const {account, name, tenant} = res.data;
      // eslint-disable-next-line no-undef
      sensorsdata.login(md5(tenant + 'M' + res.data.userId));
      window.sensorsdataTenant = tenant;
      window.gjUserInfo = res.data;
      // eslint-disable-next-line no-undef
      sensorsdata.setProfile({app: 'M', account, name, companyName: tenant});
      return Promise.resolve(res.data);
    });
}

export function logout() {
  return new Promise(resolve => {
    setTimeout(() => resolve(), 500);
  });
}

export function getUserOptions(status) {
  return request.get(`/authority/user/userCombobox?status=${status}`)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

//获取租户是否付费
export function queryTenant() {
  return request.post('/oauth/anno/queryTenant')
      .then((res) => {
        return Promise.resolve(res.data);
      });
}

export function getUserMenus() {
  return request.get(`/oauth/menu/menus`)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function getUserResources() {
  return request.get(`/authority/resource/visible`)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function validPhone(params, telephoneCode) {
  return request.post(`/oauth/anno/forgetPwdCaptcha?telephoneCode=${telephoneCode}`, params)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function updatePassword(code, phone, newPwd, telCode) {
  return request.post(`/oauth/anno/forgetPwdConfirm?phone=${phone}&verificationCode=${code}&newPwd=${newPwd}&internationalTelephoneCode=${telCode}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}

export function getLoginMsg(params) {
  return request.post('/msgs/msgsCenterInfo/loginMsg', params)
    .then((res) => {
      return Promise.resolve(res.data);
    })
}

// 获取CaptchaAppId
export function getCaptchaAppId() {
  return request.get(`/base/verification/anno/getCaptchaAppId`).then((res) => {
    return Promise.resolve(res.data);
  })
}

export function validImgCode(params) {
  return request.get(`/base/verification/anno/getResult`, { params })
    .then((res) => {
      return Promise.resolve(res.data);
    })
}
// 查询用户参数配置
export function queryUserConfig(name) {
  return request.get(`/base/customConfig/getContentByName?name=${name}`).then(res => {
    return Promise.resolve(res.data)
  }).catch(err => {
    return Promise.reject(err)
  })
}
// 修改用户参数配置
export function editUserConfig(data) {
  return request.post(`base/customConfig/saveOrUpdate`, data)
}

//删除新手指导
export const deletePrompt=()=> {
 return request.post(`/base/newbieTask/deleteTask`).then(res =>{
   return Promise.resolve(res.data)
 }).catch(err => {
   return Promise.reject(err)
 })
}


// 获取个人中心弹框数据
export function getTenantOrderDetailed() {
    return request.get(`/defaults/tenant/getTenantOrderDetailed`).then(res => {
        return Promise.resolve(res.data)
    }).catch(err => {
        return Promise.reject(err)
    })
}














